import { useQuery } from "@apollo/client";
import { SALES_ARGUMENT } from "../sales-argument.queries";
import {
  SalesArgumentQuery,
  SalesArgumentQueryVariables,
} from "../../../__generated__/SalesArgumentQuery";

export const useSalesArgument = (id: number) => {
  return useQuery<SalesArgumentQuery, SalesArgumentQueryVariables>(SALES_ARGUMENT, {
    variables: { id },
  });
};
